import React, { useCallback } from "react";
import { Paths } from "../../../Paths";
import { Menus } from "./components/Menus";
import { DesktopSideMenu } from "../side_menu/DesktopSideMenu";
import { GlobalHeaderProps } from "./GlobalHeader";
import { useNavigate } from "react-router-dom";
import { HeaderLogo } from "./HeaderLogo";

export const DesktopHeader = React.memo(function DesktopHeader(props: GlobalHeaderProps) {
    const { withSideMenu } = props;

    const navigate = useNavigate();

    const handleTitleClicked = useCallback(() => {
        navigate(Paths.root);
    }, [navigate]);

    return (
        <div className={"global_header"}>
            {/* タイトル */}
            <div className={"global_header__title"}>
                <div className={"logo"} onClick={handleTitleClicked}>
                    <HeaderLogo />
                </div>
            </div>
            {/* メニュー */}
            <Menus />
            {/* サイドメニュー */}
            {withSideMenu && <DesktopSideMenu />}
        </div>
    );
});
